import Vue from "vue";
import {
    AbacoWebModule,
    RouterReadyEvent,
    VueRouter,
    MenuItem,
    ApplicationReadyEvent
} from "@abaco/web-common/src/app";
import globals from "./globals";
import myRoutes from "./routes";
import ActivitiesVuexModule from "./state";
import { createMenu } from "./menu";
import ActivityLinkApi from "./api/ActivityLinkApi";
import FertilizerApi from "./api/FertilizerApi";
import WaterApi from "./api/WaterApi";
import ScanApi from "./api/ScanApi";
import UnitOfMeasureApi from "./api/UnitsOfMeasureApi";
import PhytochemicalApi from "./api/PhytochemicalApi";
import SeedApi from "./api/SeedApi";
import IrrigationApi from "./api/IrrigationApi";
import { UnitOfMeasure } from "./models/UnitsOfMeasure";
import WorkerApi from "./api/WorkerApi";
import EquipmentApi from "./api/EquipmentApi";
import ElectricityApi from "./api/ElectricityApi";
import ActionApi from "./api/ActionApi";
import WarehouseApi from "./api/WarehouseApi";
import DeliveryApi from "./api/DeliveryApi";
import { HTTPClient } from "@abaco/web-common/src/HTTP";
import ActivityApi from "./api/ActivityApi";
import ProductApi from "./api/ProductApi";
import DocumentApi from "./api/DocumentApi";
import FieldRegistryApi from "./api/FieldRegistryApi";
import FarmerRegistryModule, { MODULE_ID as FARM_MODULE_ID } from "@abaco/farm-registry/src/modules/farm-registry";
import GeophotoModule, { MODULE_ID as GEOPHOTO_MODULE_ID } from "@abaco/geo-tagging/src/abaco-module";
import GlobalStateModule, { MODULE_ID as GLOBAL_MODULE_ID } from "@abaco/portal-global-state/src/modules/global-state";
import DashboardModule from "@abaco/dashboard-module/src/modules/dashboard";
import DashboardChartsModule from "@abaco/dashboard-module/src/modules/charts";
import SsoVuexModule from "@abaco/sso-web-module/src/abaco-module/state";
import SSOModule, { MODULE_ID as SSO_MODULE_ID } from "@abaco/sso-web-module/src/abaco-module";
import CropPlanModule from "@abaco/crop-plan-module/src/modules/crop-plan-module/index";
import TrackApi from "./api/TrackApi";
import TrackSynvhApi from "./api/TracksSynchApi";
import ViolationApi from "./api/ViolationApi";
import WeatherApi from "./api/WeatherApi";
import FuelApi from "./api/FuelApi";
import UsersApi from "./api/UsersApi";
import PrintApi from "./api/PrintApi";
import RecipeMapApi from "./api/RecipeMapApi";

import PortalGlobalStateModule from "@abaco/portal-global-state/src/modules/global-state";
import DownloadApi from "./api/DownloadApi";
import SensorXApi from "./api/SensorXApi";

export const MODULE_ID = "activities_module";

const state = new ActivitiesVuexModule();
const rootPath = "/sitiagri-rest-api/api_basic";

export default class ActivitiesModule implements AbacoWebModule {
    public static MODULE_ID = MODULE_ID;

    private router!: VueRouter;
    private ssoStore!: SsoVuexModule;

    private apiCreated = false;
    private actApi!: ActivityApi;
    private fertApi!: FertilizerApi;
    private watApi!: WaterApi;
    private scnApi!: ScanApi;
    private uomApi!: UnitOfMeasureApi;
    private phytoApi!: PhytochemicalApi;
    private prdApi!: ProductApi;
    private irrApi!: IrrigationApi;
    private wkrApi!: WorkerApi;
    private eqpApi!: EquipmentApi;
    private elcApi!: ElectricityApi;
    private exeApi!: ActionApi;
    private warApi!: WarehouseApi;
    private trkApi!: TrackApi;
    private trksyncApi!: TrackSynvhApi;
    private seeApi!: SeedApi;
    private vltApi!: ViolationApi;
    private docApi!: DocumentApi;
    private usrApi!: UsersApi;
    private cfrApi!: DeliveryApi;
    private weathApi!: WeatherApi;
    private prtApi!: PrintApi;
    private flrApi!: FieldRegistryApi;
    private fueApi!: FuelApi;
    private recApi!: RecipeMapApi;
    private dwnApi!: DownloadApi;
    private aclApi!: ActivityLinkApi;
    private sxApi!: SensorXApi;
    private trackServerEnv!: string;

    readonly id = MODULE_ID;
    readonly routes = myRoutes;
    readonly globalComponents = globals;
    readonly vuexModule = state;

    menu: MenuItem[] = [];

    dependsOn = {
        [FARM_MODULE_ID]: () => new FarmerRegistryModule(),
        [GLOBAL_MODULE_ID]: () => new GlobalStateModule(),
        [DashboardModule.MODULE_ID]: () => new DashboardModule(),
        [DashboardChartsModule.MODULE_ID]: () => new DashboardChartsModule(),
        [CropPlanModule.MODULE_ID]: () => new CropPlanModule(),
        [PortalGlobalStateModule.MODULE_ID]: () => new PortalGlobalStateModule(),
        [GeophotoModule.MODULE_ID]: () => new GeophotoModule()
    };

    onRouterReady(evt: RouterReadyEvent) {
        this.router = evt.router;
        this.menu = createMenu(this.router);
        // Vue.filter("only4Digits", (val: number, additionalText: string) => {
        //     return `${Number(val).toLocaleString(this.getLocale(), {
        //         minimumFractionDigits: 4,
        //         maximumFractionDigits: 4
        //     })} ${additionalText}`;
        // });
    }

    async beforeEnterAnyRoutes(http: HTTPClient) {
        if (this.apiCreated) {
            return;
        }
        this.apiCreated = true;

        const ActivityApi = (await import("./api/ActivityApi")).default;
        this.actApi = new ActivityApi(http);

        const FertilizerApi = (await import("./api/FertilizerApi")).default;
        this.fertApi = new FertilizerApi(http, rootPath);

        const WaterApi = (await import("./api/WaterApi")).default;
        this.watApi = new WaterApi(http, rootPath);

        const ScanApi = (await import("./api/ScanApi")).default;
        this.scnApi = new ScanApi(http, rootPath);

        const UnitOfMeasureApi = (await import("./api/UnitsOfMeasureApi")).default;
        this.uomApi = new UnitOfMeasureApi(http, rootPath);

        const PhytochemicalApi = (await import("./api/PhytochemicalApi")).default;
        this.phytoApi = new PhytochemicalApi(http, rootPath);

        const ProductApi = (await import("./api/ProductApi")).default;
        this.prdApi = new ProductApi(http, rootPath);

        const IrrigationApi = (await import("./api/IrrigationApi")).default;
        this.irrApi = new IrrigationApi(http, rootPath);

        const WorkerApi = (await import("./api/WorkerApi")).default;
        this.wkrApi = new WorkerApi(http, rootPath);

        const EquipmentApi = (await import("./api/EquipmentApi")).default;
        this.eqpApi = new EquipmentApi(http, rootPath);

        const ElectricityApi = (await import("./api/ElectricityApi")).default;
        this.elcApi = new ElectricityApi(http, rootPath);

        const ActionApi = (await import("./api/ActionApi")).default;
        this.exeApi = new ActionApi(http, rootPath);

        const WarehouseApi = (await import("./api/WarehouseApi")).default;
        this.warApi = new WarehouseApi(http, rootPath);

        const TrackApi = (await import("./api/TrackApi")).default;
        this.trkApi = new TrackApi(http, rootPath);

        const TrackSynchApi = (await import("./api/TracksSynchApi")).default;
        this.trksyncApi = new TrackSynchApi(http, rootPath);

        const SeedApi = (await import("./api/SeedApi")).default;
        this.seeApi = new SeedApi(http, rootPath);

        const ViolationApi = (await import("./api/ViolationApi")).default;
        this.vltApi = new ViolationApi(http, rootPath);

        const DocumentApi = (await import("./api/DocumentApi")).default;
        this.docApi = new DocumentApi(http, rootPath);

        const UsersApi = (await import("./api/UsersApi")).default;
        this.usrApi = new UsersApi(http, rootPath, this.trackServerEnv);

        const DeliveryApi = (await import("./api/DeliveryApi")).default;
        this.cfrApi = new DeliveryApi(http, rootPath);

        const WeatherApi = (await import("./api/WeatherApi")).default;
        this.weathApi = new WeatherApi(http, rootPath);

        const PrintApi = (await import("./api/PrintApi")).default;
        this.prtApi = new PrintApi(http, rootPath);

        const FieldRegistryApi = (await import("./api/FieldRegistryApi")).default;
        this.flrApi = new FieldRegistryApi(http, rootPath);

        const FuelApi = (await import("./api/FuelApi")).default;
        this.fueApi = new FuelApi(http, rootPath);

        const RecipeMapApi = (await import("./api/RecipeMapApi")).default;
        this.recApi = new RecipeMapApi(http);

        const DownloadApi = (await import("./api/DownloadApi")).default;
        this.dwnApi = new DownloadApi(http, rootPath);

        const ActivityLinkApi = (await import("./api/ActivityLinkApi")).default;
        this.aclApi = new ActivityLinkApi(http, rootPath);

        const SensorXApi = (await import("./api/SensorXApi")).default;
        this.sxApi = new SensorXApi(http);
    }

    get activityApi() {
        return this.actApi;
    }

    get fertilizerApi() {
        return this.fertApi;
    }

    get unitOfMeasureApi() {
        return this.uomApi;
    }

    get phytoChemicalApi() {
        return this.phytoApi;
    }

    get productApi() {
        return this.prdApi;
    }

    get irrigationApi() {
        return this.irrApi;
    }

    get workerApi() {
        return this.wkrApi;
    }

    get equipmentApi() {
        return this.eqpApi;
    }

    get electricityApi() {
        return this.elcApi;
    }

    get actionApi() {
        return this.exeApi;
    }

    get warehouseApi() {
        return this.warApi;
    }

    get trackApi() {
        return this.trkApi;
    }

    get trackSynchApi() {
        return this.trksyncApi;
    }

    get seedApi() {
        return this.seeApi;
    }

    get violationApi() {
        return this.vltApi;
    }

    get documentApi() {
        return this.docApi;
    }

    get waterApi() {
        return this.watApi;
    }

    get scanApi() {
        return this.scnApi;
    }

    get usersApi() {
        return this.usrApi;
    }

    get deliveryApi() {
        return this.cfrApi;
    }

    get weatherApi() {
        return this.weathApi;
    }

    get printApi() {
        return this.prtApi;
    }

    get fuelApi() {
        return this.fueApi;
    }

    get fieldRegistryApi() {
        return this.flrApi;
    }

    get recipeMapApi() {
        return this.recApi;
    }

    get downloadApi() {
        return this.dwnApi;
    }

    get activityLinkApi() {
        return this.aclApi;
    }
    get sensorXApi() {
        return this.sxApi;
    }

    public async updateUoms(family_name?: string, decodes = false): Promise<UnitOfMeasure[] | null> {
        if (!family_name) {
            return null;
        }
        if (!this.vuexModule.unitConversions || this.vuexModule.unitConversions.length == 0) {
            const res = await this.unitOfMeasureApi.getUnitConversions();
            this.vuexModule.unitConversions = res;
        }
        if (!this.vuexModule.unitOfMeasures[family_name]) {
            const res = decodes
                ? await this.unitOfMeasureApi.getDecodesUoms(family_name)
                : await this.unitOfMeasureApi.getWarehouseUoms(family_name);
            this.vuexModule.unitOfMeasures[family_name] = res;
            return this.vuexModule.unitOfMeasures[family_name];
        }
        return this.vuexModule.unitOfMeasures[family_name];
    }

    public async updateCompentences(pkCuaa: number) {
        const [
            canEditAction,
            canValidateExecution,
            canViewAction,
            canEditFieldRegistry,
            canEditActivity,
            canViewActivity,
            canSelectWarehouse,
            canViewExecutionCost,
            canEditExecutionCost,
            canViewWorker,
            canViewTracks,
            canViewSustainability,
            canEditSustainability,
            canSelectSuppliersFertilizer,
            canManageIotMaps,
            canUploadActivity,
            canDownloadActivity,
            canManageEquipmentVolume,
            canManageScans,
            canLinkActivities,
            canEditPlannedResources,
            plotSettings
        ] = await Promise.all([
            this.actionApi.canEditAction(pkCuaa),
            this.actionApi.canValidateExecution(pkCuaa),
            this.actionApi.canViewAction(pkCuaa),
            this.actionApi.canEditFieldRegistry(pkCuaa),
            this.activityApi.canEditActivity(pkCuaa),
            this.activityApi.canViewActivity(pkCuaa),
            this.warehouseApi.canSelectWarehouse(pkCuaa),
            this.usersApi.canViewExecutionCost(pkCuaa),
            this.usersApi.canEditExecutionCost(pkCuaa),
            this.activityApi.canViewWorker(pkCuaa),
            this.trackApi.canViewTracks(pkCuaa),
            this.activityApi.canViewSustainability(pkCuaa),
            this.activityApi.canEditSustainability(pkCuaa),
            this.warehouseApi.canSelectSuppliersFertilizer(pkCuaa),
            this.actionApi.canManageIotMaps(pkCuaa),
            this.activityApi.canUploadActivity(pkCuaa),
            this.activityApi.canDownloadActivity(pkCuaa),
            this.equipmentApi.canManageEquipmentVolume(pkCuaa),
            this.scanApi.canManageScans(pkCuaa),
            this.activityLinkApi.canLinkActivities(pkCuaa),
            this.activityApi.canEditPlannedResources(pkCuaa),
            this.activityApi.getPlotSettings(pkCuaa)
        ]);
        this.vuexModule.canEditAction = canEditAction;
        this.vuexModule.canValidateExecution = canValidateExecution;
        this.vuexModule.canViewAction = canViewAction;
        this.vuexModule.canEditFieldRegistry = canEditFieldRegistry;
        this.vuexModule.canEditActivity = canEditActivity;
        this.vuexModule.canViewActivity = canViewActivity;
        this.vuexModule.canSelectWarehouse = canSelectWarehouse;
        this.vuexModule.canViewExecutionCost = canViewExecutionCost;
        this.vuexModule.canEditExecutionCost = canEditExecutionCost;
        this.vuexModule.canViewWorker = canViewWorker;
        this.vuexModule.canViewTracks = canViewTracks;
        this.vuexModule.canViewSustainability = canViewSustainability;
        this.vuexModule.canEditSustainability = canEditSustainability;
        this.vuexModule.canSelectSuppliersFertilizer = canSelectSuppliersFertilizer;
        this.vuexModule.canManageIotMaps = canManageIotMaps;
        this.vuexModule.canUploadActivity = canUploadActivity;
        this.vuexModule.canDownloadActivity = canDownloadActivity;
        this.vuexModule.canManageEquipmentVolume = canManageEquipmentVolume;
        this.vuexModule.canManageScans = canManageScans;
        this.vuexModule.canLinkActivities = canLinkActivities;
        this.vuexModule.canEditPlannedResources = canEditPlannedResources;
        this.vuexModule.plotSettings = plotSettings;
    }

    public setIsProtocol(val: boolean) {
        this.vuexModule.isProtocol = val;
    }

    async onApplicationReady(evt: ApplicationReadyEvent) {
        const ssoModule = evt.modules.find(m => m.id === SSO_MODULE_ID) as SSOModule | undefined;
        if (!ssoModule) {
            throw new Error("SSOModule not found!");
        }

        this.ssoStore = ssoModule.vuexModule;
        this.trackServerEnv = evt.envConfig["tracksServerEnv"];

        Vue.filter("only4Digits", (val: number, additionalText: string) => {
            return `${Number(val).toLocaleString(ssoModule.vuexModule.user?.locale, {
                minimumFractionDigits: 4,
                maximumFractionDigits: 4
            })} ${additionalText}`;
        });
        Vue.filter("only2Digits", (val: number, additionalText: string) => {
            return `${Number(val).toLocaleString(ssoModule.vuexModule.user?.locale, {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            })} ${additionalText}`;
        });
    }
}
